'use client'

import type { Cruz } from '@cruz-com/lookup'
import { asyncSleep } from 'modern-async'
import io, { type Socket } from 'socket.io-client'
import { getAccessToken } from '@/api/util'

export namespace cruzSocket {
  export var socket: Socket

  export async function init(user: Cruz.User, pathname: string | null) {
    const accessToken = await getAccessToken()
    socket = io(`${process.env.NEXT_PUBLIC_SOCKET_URL}/admin`, {
      auth: {
        token: accessToken,
        email: user?.email,
        pathname,
      },
    })
  }

  export async function reconnect() {
    if (socket) {
      socket.disconnect()
    }
    await asyncSleep(1)
    socket.connect()
  }

  export async function disconnect() {
    socket.disconnect()
  }
}
